import React, { FC } from 'react'
import * as pageUtils from './__details.utils'
import { formatStrapiText, getLabelFromList } from '@utils/methods'
import { RadioList } from '@utils/request'

const FireHydrantsTempAqueductNetworkFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	const radioListYesNo: RadioList[] = [
		{
			label: pageAssets.request_form_select_yes,
			value: 'true',
			key: 'request_form_select_yes'
		},
		{
			label: pageAssets.request_form_select_no,
			value: 'false',
			key: 'request_form_select_no'
		}
	]
	return (
		<>
			<h4 className={pageUtils.classes.h4}>
				{pageAssets?.request_form_company_information}
			</h4>

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_annualRegistrationCertificateForContractors_companyName_label
					}
				</b>
				<br />
				<span>{request.incidentForm?.business?.organization_name}</span>
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b>{pageAssets.request_form_isSameAdresse_label}</b>
				<br />
				<span>
					{getLabelFromList(
						radioListYesNo,
						request.incidentForm?.businessSameAsPersonal
					)}
				</span>
			</p>

			{request.incidentForm?.businessSameAsPersonal?.toString() == 'false' && (
				<>
					<p className={pageUtils.classes.paragraph}>
						<b>{pageAssets.label_address}</b>
						<br />
						{request.incidentForm?.business?.address}
						<br />

						{/* en cas de adresse en dehors de Laval */}
						{!!request.incidentForm?.business?.city && (
							<>{request.incidentForm?.business?.city} </>
						)}
						{!!request.incidentForm?.business?.postal_code && (
							<>{request.incidentForm?.business?.postal_code} </>
						)}
						{!!request.incidentForm?.business?.state && (
							<>{request.incidentForm?.business?.state} </>
						)}
						{!!request.incidentForm?.business?.country && (
							<>
								{request.incidentForm?.business?.country} <br />
							</>
						)}
						{/* ---------------------------------- */}

						{request.incidentForm?.business?.appartment
							? `${formatStrapiText(pageAssets?.label_apartment_office)} ${
									request.incidentForm?.business?.appartment
							  }`
							: ''}
					</p>
				</>
			)}

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_hydraulicAndPressureTest_is_this_a_contract_with_city
					}
				</b>
				<br />
				<span>
					{getLabelFromList(
						radioListYesNo,
						request.incidentForm?.isContractWithCity
					)}
				</span>
			</p>

			{request.incidentForm?.isContractWithCity?.toString() == 'true' && (
				<>
					<p className={pageUtils.classes.paragraph}>
						<b>
							{pageAssets.request_form_hydraulicAndPressureTest_contract_number}
						</b>
						<br />
						<span>{request.incidentForm?.contractNumber}</span>
					</p>

					<p className={pageUtils.classes.paragraph}>
						<b>
							{
								pageAssets.request_form_hydraulicAndPressureTest_name_of_respondent_at_city
							}
						</b>
						<br />
						<span>{request.incidentForm?.cityRespondentName}</span>
					</p>
				</>
			)}

			<h4 className={pageUtils.classes.h4}>
				{
					pageAssets?.request_form_fireHydrantsTempAqueductNetwork_installation_title
				}
			</h4>

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_fireHydrantsTempAqueductNetwork_startDate_label
					}
				</b>
				<br />
				<span>{pageUtils.getLocaleDate(request.incidentForm?.startDate!)}</span>
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_fireHydrantsTempAqueductNetwork_endDate_label
					}
				</b>
				<br />
				<span>{pageUtils.getLocaleDate(request.incidentForm?.endDate!)}</span>
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_fireHydrantsTempAqueductNetwork_whichFireHydrantToUse_label
					}
				</b>
				<br />
				<span>{request.incidentForm?.whichFireHydrantToUse}</span>
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b>
					{
						pageAssets.request_form_fireHydrantsTempAqueductNetwork_firmInChargeOfTemporaryNetwork_label
					}
				</b>
				<br />
				<span>{request.incidentForm?.firmInChargeOfTemporaryNetwork}</span>
			</p>

			{request.incidentForm?.contractorInChargeOfWorks && (
				<p className={pageUtils.classes.paragraph}>
					<b>
						{
							pageAssets.request_form_fireHydrantsTempAqueductNetwork_contractorInChargeOfWorks_label
						}
					</b>
					<br />
					<span>{request.incidentForm?.contractorInChargeOfWorks}</span>
				</p>
			)}
		</>
	)
}

export default FireHydrantsTempAqueductNetworkFormDetails
